import NameSpace from '../ns/NameSpace'

/**
 * TransitionView
 */
class TransitionView {
  // ---------------------------------------------------------------------------------------------------------
	// --	TransitionView
	// ---------------------------------------------------------------------------------------------------------

  constructor(){this.isInit = false;}

  init()
  {
    if(this.isInit) return;
    this.isInit = true;

    //DOM配置
    let html = '  <div id="transition" class="transition">';
    html += '  <div id="transition__inner" class="transition__inner"></div>';
    html += '  </div>';
    document.body.insertAdjacentHTML('beforeend', html);

    //DOM参照
    this.transition = document.getElementById('transition');
    this.inner = document.getElementById('transition__inner');

    //ピンチ対策
    this.transition.addEventListener('touchstart', (e)=>{
      e.preventDefault();
    })

    //リセット
    this.reset();
  }

  reset()
  {
    this.transition.style.display = 'none';
  }

  show(delay = 0)
  {
    return new Promise((resolve, reject) =>
    {
      //初期化
      gsap.set(this.inner, {scaleX:0, scaleY:0});
      this.transition.style.display = 'block';

      //アニメーション
      gsap.to(this.inner, 0.6, {
        scaleX    :1.0,
        scaleY    :1.0,
        delay     :delay,
        ease      :'power2.in',
        onComplete:()=>{
          resolve();
        }
      });
    })
  }

  hide(delay = 0)
  {
    return new Promise((resolve, reject) =>
    {
      setTimeout(()=>{

        //アニメーション
        gsap.to(this.inner, 0.8, {
          scaleX    :0.0,
          scaleY    :0.0,
          ease      :'power2.in',
          onComplete:()=>{
            resolve();
          }
        });

      }, delay*1000);
    })
  }

	// ---------------------------------------------------------------------------------------------------------
}

if(!NameSpace.getNameSpace('okawari.common.view').TransitionView)
  NameSpace.getNameSpace('okawari.common.view').TransitionView = new TransitionView();
export default NameSpace.getNameSpace('okawari.common.view').TransitionView;